import { ManagementEditPage } from './edit';
import { alertSuccess, alertError } from '@cems-eco/core/src/utils/widget';

export class DemoManagementEditPage extends ManagementEditPage {

    mounted() {
        this.management = {
            id: '1',
            _method: '',
            client_id: 'client',
            contract_expiry: '2024-09-10',
            installation_date: '2021-09-10',
            contract_value: '',
            service_contract_value: '',
            additional: '',
        };
    }

    async save() {
        try {
            alertSuccess('Good Job!', 'You have successfully edit this Maintenance');
            this.$router.push(`/management`);
        } catch (error) {
            console.log(error);
        }
    }
}